function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "85.889%",
  y1: "11.841%",
  x2: "20.24%",
  y2: "96.217%",
  id: "PDAM_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#59F1DD",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00C2D5",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "64.168%",
  y1: "0%",
  x2: "-50.19%",
  y2: "58.691%",
  id: "PDAM_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B4FFF5",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#54E2EF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "100%",
  y1: "46.885%",
  x2: "8.54%",
  y2: "53.773%",
  id: "PDAM_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#59F1DD",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00C2D5",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "78.414%",
  y1: "11.841%",
  x2: "26.439%",
  y2: "96.217%",
  id: "PDAM_svg__d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#59F1DD",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00C2D5",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.222 1.222)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "url(#PDAM_svg__a)",
  x: 10.236,
  y: 8.556,
  width: 9.319,
  height: 11,
  rx: 1.55
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.189 8.556h7.77v9.45a1.55 1.55 0 01-1.55 1.55h-6.22a1.55 1.55 0 01-1.55-1.55v-7.9c0-.856.694-1.55 1.55-1.55z",
  fill: "url(#PDAM_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.55 0h12.178c.856 0 1.55.694 1.55 1.55v16.456a1.55 1.55 0 01-1.55 1.55H1.55A1.55 1.55 0 010 18.006V1.55C0 .694.694 0 1.55 0z",
  fill: "url(#PDAM_svg__b)"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#PDAM_svg__c)",
  x: 9.778,
  y: 2.292,
  width: 3.208,
  height: 1,
  rx: 0.465
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#PDAM_svg__c)",
  x: 2.292,
  y: 16.347,
  width: 3.208,
  height: 1,
  rx: 0.465
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.563 14.82c2.067 0 3.743-1.69 3.743-3.774 0-1.333-1.148-3.275-3.444-5.828a.403.403 0 00-.6 0C4.968 7.771 3.82 9.713 3.82 11.046c0 2.084 1.676 3.773 3.744 3.773z",
  fill: "url(#PDAM_svg__d)"
}));

function SvgPdam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgPdam;